import { render, staticRenderFns } from "./CourseDateSingle.vue?vue&type=template&id=60f7206c&scoped=true&"
import script from "./CourseDateSingle.vue?vue&type=script&lang=js&"
export * from "./CourseDateSingle.vue?vue&type=script&lang=js&"
import style0 from "./CourseDateSingle.vue?vue&type=style&index=0&id=60f7206c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60f7206c",
  null
  
)

export default component.exports